import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";

const DefaultLayout = () => {

    return(
        <div>
            <Navbar />
            <div className="container mx-auto" style={{ minHeight: 'calc(100vh - 90px)' }}>
                <Outlet />
            </div>
        </div>
    )
}

export default DefaultLayout;